import { Void } from "../functions/Void"
import type { AsyncSequence } from "../types/AsyncSequence"
import { SafeIterable } from "./SafeIterable"

export async function ProcessIterable<T>(
  iterable: AsyncSequence<T>,
  on_yield: (data: T, index: number) => void = Void,
  on_stop: (error: Error | undefined) => void = e => {
    if (e) throw e
  }
): Promise<void> {
  let index = 0
  const { stream, error } = SafeIterable(iterable)
  for await (const data of stream) {
    void on_yield(data, index++)
  }
  return on_stop(await error)
}
